import { ButtonStyleProps, buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { FormattedMessage } from 'react-intl';

type ApplyColor = 'warning' | 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info';

interface Props {
    onSecondary?: () => void;
    onPrimary?: () => void;
    applyColor?: ApplyColor;
    beforeActions?: React.ReactNode;
}

/** The apply button's colours, for the names the kit button draws. Anything else takes the brand green. */
const APPLY_COLOR: Partial<Record<ApplyColor, ButtonStyleProps['color']>> = {
    primary: 'primary',
    secondary: 'secondary',
    error: 'error',
    info: 'info',
};

export const DrawerFooter = ({ onSecondary, onPrimary, applyColor = 'success', beforeActions }: Props): JSX.Element => {
    if (!onSecondary && !onPrimary && !beforeActions) {
        return <div />;
    }

    return (
        <div className="border-divider bg-grey-0 sticky bottom-0 flex w-full items-center justify-between border-t px-6 py-4">
            {onSecondary || beforeActions ? (
                <div className="flex items-center gap-4">
                    {onSecondary && (
                        <Button {...buttonStyle({ variant: 'outlined' }, 'px-4')} onClick={onSecondary}>
                            <FormattedMessage id="clear" />
                        </Button>
                    )}
                    {beforeActions}
                </div>
            ) : null}

            {onPrimary && (
                <Button
                    {...buttonStyle({ variant: 'contained', color: APPLY_COLOR[applyColor] ?? 'primary' })}
                    onClick={onPrimary}
                >
                    <FormattedMessage id="apply" />
                </Button>
            )}
        </div>
    );
};
